module.exports = __webpack_public_path__ + "img/banner.641988c6.png";